import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandButton',
  props: {
    hidden: { type: Boolean },
    expanded: { type: Boolean }
  },
  emits: ["update:expanded"],
  setup(__props: any, { emit }) {

const props = __props;





function onClick() {
  emit('update:expanded', !props.expanded)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "btn btn-unstyled expand-button",
    role: "button",
    tabindex: "0",
    onClick: onClick
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["expand-icon", { expanded: props.expanded, hidden: props.hidden }])
    }, null, 2)
  ]))
}
}

})